export const AS_INVESTIGATION_WIZARD_STEPS  = [
  "Day 1",
  "Day 2",
  "Day 3",
  "Day 4",
  "Day 5",
  "Day 10",
  "Day 15",
  "Day 20",
];

export const STEP_STATUS_MAP  = {
  1: 0,
  2: 0,
  3: 1,
  4: 2,
  5: 3,
  6: 4,
  7: 5,
  8: 6,
  9: 7,
  10: 7,
  11: 7,
};

export const STEPS_REQUIRED_MAP = {
  1: [0],
  2: [0, 1],
  3: [0, 1, 2],
  4: [0, 1, 2, 3],
  5: [0, 1, 2, 3, 4],
  10: [0, 1, 2, 3, 4, 5],
  15: [0, 1, 2, 3, 4, 5, 6],
  20: [0, 1, 2, 3, 4, 5, 6, 7],
};

export const INVESTIGATION_DONE_STEP_MAP = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  4: 5,
  5: 6,
  10: 7,
  15: 8,
  20: 8,
};

export const FREIGHT_LOCATED_STEP_MAP = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  10: 6,
  15: 7,
  20: 7,
};
export const STEP_DAY_MAPPING  = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  4: 5,
  5: 10,
  6: 15,
  7: 20,
};

export enum EShortageInvestigationStatus {
  exceptionEntry = 1,
  day1InProgress = 2,
  day2InProgress = 3,
  day3InProgress = 4,
  day4InProgress = 5,
  day5InProgress = 6,
  day10InProgress = 7,
  day15InProgress = 8,
  day20InProgress = 9,
  pendingSrApproval = 10,
  complete = 11,
}

export enum EBNFStatus {
  exceptionEntry = 1,
  needsCleared = 12,
}

export enum EOverageInvestigationStatus {
  exceptionEntry = 1,
  inProgress = 13,
  complete = 11,
}
export const AS_DAY_1_FIELDS  = [
  "showAtDestTerm",
  "dateToDestTerm",
  "notInDestTerm",
  "notInDestTermSteps",
  "day1F18Note",
];

export const AS_DAY_2_FIELDS  = [
  "noMovement",
  "dateLastMovement",
  "noMovementSteps",
  "suffixBill",
  "suffixBillSteps",
  "bolCheck",
  "bolCheckSteps",
  "drCheck",
  "drCheckSteps",
  "day2F18Note",
];
export const AS_DAY_3_FIELDS  = [
  "pumCheck",
  "pickupManifest",
  "pumSteps",
  "shipperLoad",
  "discrepancies",
  "checkLinehaulManifests",
  "linehaulManifests",
  "interviewWorkers",
  "workerSteps",
  "consigneePhone",
  "consigneeName",
  "consigneeShort",
  "itemNumbers",
  "orderReceived",
  "freightLabeled",
  "shipperPhone",
  "shipperName",
  "shippedDetails",
  "shortShipped",
  "productValue",
  "multShipments",
  "day3F18Note",
];
export const AS_DAY_4_FIELDS  = [
  "check7818",
  "details7818",
  "manifested",
  "cameraFindings",
  "callSameDays",
  "callSameDaysDataset",
  "day4F18Note",
];
export const AS_DAY_5_FIELDS  = [
  "contactTerminals",
  "freightTerminalLeadInquiries",
  "day5F18Note",
];
export const AS_DAY_10_FIELDS  = ["followUp", "followUpDetails", "day10F18Note"];
export const AS_DAY_15_FIELDS  = [
  "check7818_2",
  "details7818_2",
  "highValue",
  "day15F18Note",
];
export const AS_DAY_20_FIELDS  = ["finalReCheck", "detailsOfSearch", "day20F18Note"];


export const AS_ALL_INVESTIGATION_FIELDS_GROUPED  = [
  AS_DAY_1_FIELDS,
  AS_DAY_2_FIELDS,
  AS_DAY_3_FIELDS,
  AS_DAY_4_FIELDS,
  AS_DAY_5_FIELDS,
  AS_DAY_10_FIELDS,
  AS_DAY_15_FIELDS,
  AS_DAY_20_FIELDS,
];


export enum EASInvestigationFieldsErrorMessage {
  day1 = "Day 1 is completed. Required field cannot be left blank.",
  day2 = "Day 2 is completed. Required field cannot be left blank.",
  day3 = "Day 3 is completed. Required field cannot be left blank.",
  day4 = "Day 4 is completed. Required field cannot be left blank.",
  day5 = "Day 5 is completed. Required field cannot be left blank.",
  day10 = "Day 10 is completed. Required field cannot be left blank.",
  day15 = "Day 15 is completed. Required field cannot be left blank.",
  day20 = "Day 20 is completed. Required field cannot be left blank.",
}
